import { createSelector } from 'reselect';

const countries = (state) => state.countries.countries;

/**
 * Countries selector
 * @param  {Function} countries Function that returns all countries
 * @return {Object}             Object representing {value: id, label: name} for form fields
 */
export const countryFieldSelector = createSelector(countries, (countries) => {
	const options = {};

	countries.forEach((country) => {
		options[country.id] = country.name;
	});

	return options;
});
